import { DEFAULT_CATEGORY_NAMES } from './constants';
import { LocalCategory, PersonFormState } from './types';

export const createLocalId = () => `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const createDefaultCategories = (): LocalCategory[] => DEFAULT_CATEGORY_NAMES.map((name) => ({
    id: createLocalId(),
    name,
}));

export const createDefaultPersonFormState = (): PersonFormState => ({
    categoryId: '',
    firstName: '',
    lastName: '',
    role: '',
    availability: '',
    description: '',
    phoneNumber: '',
    email: '',
    visibleForGuests: false,
});
